"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.UPDATE_ITEM_ERRORS = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _parseObjectToFormData = _interopRequireDefault(require("../parseObjectToFormData"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const updateItem = async product => {
  if ((0, _isEmpty.default)(product)) return;
  const {
    REACT_APP_PATH
  } = process.env;
  const FETCH_URL = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.CartApi/UpdateItem.api");
  const formData = (0, _parseObjectToFormData.default)(product);
  if (localStorage.getItem("mco-shop-cart-guid")) {
    formData.append("cartGUID", localStorage.getItem("mco-shop-cart-guid"));
  }
  const headers = {};
  if (localStorage.getItem("logintoken")) {
    headers["Authorization"] = "Bearer " + localStorage.getItem("logintoken");
  }
  try {
    const response = await _axios.default.post(FETCH_URL, formData, {
      headers
    });
    const data = await response.data;
    return data;
  } catch (error) {
    return error;
  }
};
const UPDATE_ITEM_ERRORS = exports.UPDATE_ITEM_ERRORS = {
  cart_empty: "CART_NOT_UPDATED",
  cartitem_not_found: "CART_NOT_UPDATED",
  not_available: "PRODUCT_NOT_AVAILABLE",
  parameter_missing: "CART_NOT_UPDATED"
};
var _default = exports.default = updateItem;